import { render, staticRenderFns } from "./leader-list.vue?vue&type=template&id=6fe87c5e&scoped=true&"
import script from "./leader-list.vue?vue&type=script&lang=js&"
export * from "./leader-list.vue?vue&type=script&lang=js&"
import style0 from "./leader-list.vue?vue&type=style&index=0&id=6fe87c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe87c5e",
  null
  
)

export default component.exports